<app-header></app-header>
<div id="main" class="py-md-3 px-md-3 mr-3 ml-3">
  <router-outlet></router-outlet>
</div>
